import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const { user, loading, authChecked, setAuthUser } = useAuth();

  useEffect(() => {
    // If user data was passed from AuthCallback via location.state, use it
    if (location.state?.user && location.state?.token && !user) {
      setAuthUser(location.state.user, location.state.token);
    }
  }, [location.state, user, setAuthUser]);

  // Redirect to login if not authenticated
  useEffect(() => {
    if (authChecked && !loading && !user) {
      // Redirect to Google OAuth login using current origin
      window.location.href = `${window.location.origin}/api/auth/google/login?redirect=${encodeURIComponent(location.pathname)}`;
    }
  }, [authChecked, loading, user, location.pathname]);

  // Show loading spinner while checking auth
  if (loading || !authChecked) {
    return (
      <div className="min-h-screen bg-zinc-50 flex items-center justify-center">
        <div className="w-16 h-16 border-4 border-amber-500 border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  // If not authenticated, show nothing (redirect is happening in effect)
  if (!user) {
    return (
      <div className="min-h-screen bg-zinc-50 flex items-center justify-center">
        <div className="w-16 h-16 border-4 border-amber-500 border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;
